module.exports = __webpack_public_path__ + "assets/img/french.180f5bc3.png";